module.exports = __webpack_public_path__ + "static/media/Aboutus_visual.373565c0.png";